import { Injectable } from '@angular/core';

import { ApiResponse, IssueModel, OrganisationModel } from '@fleet/model';

import { OrganisationApiService } from '@fleet/api/organisation/organisation-api.service';

import { EntityHeaderService } from '@fleet/layout/entity-header-with-breadcrumbs/entity-header.service';
import { BehaviorSubject, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class OrganisationService {
  organisation: BehaviorSubject<OrganisationModel> = new BehaviorSubject(null);

  issues: Subject<IssueModel[]> = new Subject();

  constructor(
    private organisationApiService: OrganisationApiService,

    private entityHeaderService: EntityHeaderService
  ) {}

  setOrganisation(organisation: OrganisationModel) {
    this.organisation.next(organisation);
    this.entityHeaderService.setOrganisationId(
      organisation ? organisation.organisationId : null
    );
  }

  get organisation$() {
    return this.organisation.asObservable();
  }

  get organisationId() {
    return this.organisation.value
      ? this.organisation.value.organisationId
      : null;
  }

  get currentOrganisation() {
    return this.organisation.value;
  }

  getOrganisation(organisationId: string) {
    this.organisationApiService.getOrganisation(organisationId).subscribe({
      next: (resp: ApiResponse<OrganisationModel> | any) => {
        this.organisation.next(resp.data);
      },
      error: (error) => this.issues.next(error),
    });
  }
}
